/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  //////////////////////////////
  /// Market Specific
  //////////////////////////////

  approveRedemptionRequest(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("approveRedemptionRequest");
      axios
        .post(
          `${constants.marketAdminUrl}/accept-redemption?userId=${payload.userId}&orgId=${payload.orgId}`,
          {
            logId: payload.logId,
            couponIndex: payload.couponIndex,
            redemptionInstructions: payload.redemptionInstructions,
          },
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then(() => {
          // console.log(response.data);
          resolve();
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },

  rejectRedemptionRequest(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("rejectRedemptionRequest");
      axios
        .post(
          `${constants.marketAdminUrl}/reject-redemption?logId=${payload.logId}&userId=${payload.userId}&orgId=${payload.orgId}`,
          null,
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then(() => {
          // console.log(response.data);
          resolve();
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  acceptTokenMinted(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("acceptTokenMinted");
      axios
        .post(
          `${constants.marketAdminUrl}/accept-token-minted?logId=${payload.logId}&userId=${payload.userId}&orgId=${payload.orgId}`,
          null,
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then(() => {
          // console.log(response.data);
          resolve();
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  feedContractDetails(_, payload) {
    return new Promise((resolve, reject) => {
      const body = {
        contractType: payload.contractType,
        contractAddress: payload.contractAddress,
        network: payload.network,
        mintFunctionABI: payload.mintFunctionABI,
        mintFunctionParameters: payload.mintFunctionParameters,
        mintFunctionName: payload.mintFunctionName,
        mintPriceETH: payload.mintPriceETH,
      };
      // console.log("feedContractDetails");
      axios
        .post(
          `${constants.marketAdminUrl}/feed-contract-details?userId=${payload.userId}&orgId=${payload.orgId}`,
          body,
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then(() => {
          // console.log(response);
          resolve();
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  fetchContractDetails(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("fetchContractDetails");
      axios
        .post(
          `${constants.marketAdminUrl}/fetch-contract-details?userId=${payload.userId}&orgId=${payload.orgId}`,
          null,
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then((response) => {
          // console.log(response.data);
          resolve(response.data);
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  getProductDetails(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("getProductDetails");
      axios
        .get(
          `${constants.marketAdminUrl}/get-product?userId=${payload.userId}&orgId=${payload.orgId}&productId=${payload.productId}`,
          { headers: { Authorization: `Bearer ${payload.accessToken}` } }
        )
        .then((response) => {
          // // console.log(response.data);
          resolve(response.data);
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  getNFTsConfigured(_, payload) {
    return new Promise((resolve, reject) => {
      // console.log("getNFTsConfigured");

      axios
        .get(
          `${constants.marketAdminUrl}/get-nfts-configured?userId=${payload.userId}&orgId=${payload.orgId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  fulfillOrder(_, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload);

      axios
        .post(
          `${constants.marketAdminUrl}/fulfill-order?userId=${payload.userId}&orgId=${payload.orgId}&logId=${payload.logId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          // console.log(error);
          reject();
        });
    });
  },
  async fetchMarketSteps(_, payload) {
    try {
      const resObj = await axios.get(`${constants.marketAdminUrl}/get-market-step-completions?orgId=${payload.orgId}&userId=${payload.userId}`);
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  receivedOrder(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${constants.marketAdminUrl}/order-received?userId=${payload.userId}&orgId=${payload.orgId}&logId=${payload.logId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((response) => {
          console.log('order', response);          
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
    });
  },
};
